//
//
//
//
//
//

import sticky from './sticky'

export default {
  mounted () {
    this.$nextTick(() => {
      sticky(this.$el, {
        scrollBox: this.scrollBox,
        offset: this.offset,
        checkStickySupport: typeof this.checkStickySupport === 'undefined' ? true : this.checkStickySupport
      })
    })
  },
  props: ['scrollBox', 'offset', 'checkStickySupport']
}



// WEBPACK FOOTER //
// ./~/vux/src/components/sticky/index.vue